import { ReplaySubject } from 'rxjs';

import { AnyBlueconicEvent, BlueconicPaywallEvent } from './eventsInterfaces';

export const paywallSubject = new ReplaySubject<BlueconicPaywallEvent>(1);
export const modalSubject = new ReplaySubject<AnyBlueconicEvent>(1);

export const BLUECONIC = 'blueconic';
export const BlueconicClickEvent = 'CLICK';
